export const scrollDown = (
  element: HTMLElement,
  {immediate}: {immediate?: boolean} = {immediate: false},
) => {
  element.scrollTo({
    top: element.scrollHeight,
    behavior: (immediate ? 'instant' : 'smooth') as ScrollBehavior,
  });
};
